import { http } from '../http'
import { ApiError, ERROR_CODES, normalizeApiError } from '../errors'
import type { CreateMessageDataWithModel } from '@/types'

// Эндпоинты генерации НЕ используют общий beginRequest() (см. Phase 5 · Step 2):
// иначе статус-опросы разных тредов затирают общий AbortController. Отмена генерации —
// через shouldContinue в реестре задач (generation store).
//
// Тело ошибки разбирает интерцептор (normalizeApiError), здесь остаётся только
// доменный фолбэк: 422 без явного кода означает нарушение safety-политики.
export async function createImageMessage(data: CreateMessageDataWithModel) {
	try {
		const response = await http.post('/thread-images', data)
		return response.data
	} catch (error) {
		const apiError = normalizeApiError(error)
		if (apiError.status === 422 && !apiError.code) apiError.code = ERROR_CODES.IMAGE_SAFETY
		throw apiError
	}
}

export async function createImageEditMessage(data: CreateMessageDataWithModel) {
	const formData = new FormData()
	formData.append('thread_id', JSON.stringify(data.thread_id))
	formData.append('prompt', data.prompt)
	formData.append('model_name', data.model_name)
	data.image && formData.append('image', data.image)
	try {
		const response = await http.post('/thread-images', formData, {
			headers: { 'Content-Type': 'multipart/form-data' }
		})
		return response.data
	} catch (error) {
		const apiError = normalizeApiError(error)
		if (apiError.status === 422 && !apiError.code) {
			// Laravel отдаёт отказ по формату файла обычным сообщением валидации, без кода.
			apiError.code = /must be a file of type/i.test(apiError.raw ?? '')
				? ERROR_CODES.UNSUPPORTED_IMAGE
				: ERROR_CODES.IMAGE_SAFETY
		}
		throw apiError
	}
}

export async function getImageStatus(taskId: string) {
	const response = await http.get(`/thread-image-status?task_id=${taskId}`, {
		validateStatus: () => true
	})
	// validateStatus: () => true — 422 приходит успешным ответом, мимо интерцептора.
	if (response.status === 422) {
		const code = response.data?.error?.code || response.data?.code || ERROR_CODES.IMAGE_SAFETY
		throw new ApiError(code, undefined, { status: 422 })
	}
	return response.data
}
